import { Injectable } from '@angular/core';
import { DateHelper, GesdemEventService } from '@dsivd/prestations-ng';
import { Subscription } from 'rxjs';

import { BusinessForm } from '../../model/business-form';

@Injectable({ providedIn: 'root' })
export class InformationApplicantService {

    private formSubscription: Subscription;
    private _isApplicantAdult = false;

    constructor(
        private gesdemEventService: GesdemEventService,
        private dateHelper: DateHelper
    ) {
        this.formSubscription = this.gesdemEventService.formInitializationObservable().subscribe((form: BusinessForm) => {
            if (form.informationApplicant.birthDate !== null) {
                // console.log(`there ${form.informationApplicant.birthDate}`);
                this._isApplicantAdult = this.isAdult(form.informationApplicant.birthDate);
            }
        });
    }

    isApplicantAdult(): boolean {
        return this._isApplicantAdult;
    }

    private isAdult(birthDate: number[]): boolean {
        const now = new Date();
        const adultDate = [now.getFullYear() - 18, now.getMonth() + 1, now.getDate()];

        return this.dateHelper.toDateFromNumberArray(birthDate).getTime() <=
            this.dateHelper.toDateFromNumberArray(adultDate).getTime();
    }

}
